import React from 'react';

import { FeedbackCell, FeedbackForm, TableView } from '../../';
import {
  getFeedbackFormState,
  useAppSelector,
  useGetAppFeedbackQuery,
  useGetAppUpdatesQuery,
} from '@breakroom-nx/redux';
import { AppFeedbackType } from '@breakroom-nx/classes';

export interface FeedbackScrollViewProps {
  type: AppFeedbackType;
}

export function FeedbackScrollView({ type }: FeedbackScrollViewProps) {
  const formShown = useAppSelector(getFeedbackFormState);
  const {
    data: feedback,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = type === AppFeedbackType.Suggestions
    ? useGetAppFeedbackQuery()
    : useGetAppUpdatesQuery();

  const displayFeedback = () => {
    return feedback?.map((data) => {
      return (
        <FeedbackCell
          data={data}
          type={type}
          key={data.uid}
          disableComments={type === AppFeedbackType.Updates}
        />
      );
    });
  };

  return (
    <>
      {formShown && <FeedbackForm />}
      <TableView
        isLoading={isLoading}
        isSuccess={isSuccess}
        isError={isError}
        error={error}
        noData={!feedback || feedback.length < 1}
        noDataString={`No ${type.valueOf()} Yet`}
        onRefetch={refetch}
      >
        {displayFeedback()}
      </TableView>
    </>
  );
}

export default React.memo(FeedbackScrollView);
